import * as React from 'react';
import classNames from 'classnames';
import Image from 'next/image';

interface ViewStepIngredientProps {
  amount: string;
  className?: string;
  ingredient: string;
}

/**
 * @name ViewStepIngredient
 * @description tbd...
 */
const ViewStepIngredient: React.FC<ViewStepIngredientProps> = (props) => {
  const { amount, className, ingredient } = props;

  return (
    <div className={classNames(className, '')}>
      <div className="flex flex-row justify-start items-start">
        <div className="w-5 flex-none">
          <Image src="/favicon-16x16.png" width={18} height={18} />
        </div>
        <div className="text-gray-500 -mt-1 ml-1">
          {amount} {ingredient}
        </div>
      </div>
    </div>
  );
};

export { ViewStepIngredient };
export type { ViewStepIngredientProps };
